import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import "dayjs/locale/nl";
import "dayjs/locale/en"; // Make sure to import both locales
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Root from "./Root";
import UTTheme from "./theme/UTTheme";
import { Theme } from "@emotion/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { nlNL } from "@mui/x-date-pickers/locales";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
declare module "@mui/material/styles" {
  interface Palette {
    light: Palette["primary"];
    dark: Palette["primary"];
  }

  interface PaletteOptions {
    light?: PaletteOptions["primary"];
    dark?: PaletteOptions["primary"];
  }
}

const theme = createTheme(UTTheme as Theme, nlNL);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Root />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
